module.exports = __webpack_public_path__ + "img/15grzx.8aa34637.svg";